import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa6400b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sign-in"
}
const _hoisted_2 = { class: "sign-in__header" }
const _hoisted_3 = { class: "sign-in__inputs" }
const _hoisted_4 = {
  key: 0,
  class: "text-input__error-message text-input__error-message--global"
}
const _hoisted_5 = { class: "sign-in__buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "sign-in__container" }
const _hoisted_8 = {
  key: 1,
  class: "sign-in__register"
}
const _hoisted_9 = {
  key: 0,
  class: "sign-in__header"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "success-container",
  class: "sign-in__success-container"
}, null, -1))

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import dictionary from "@/i18n/dictionary.json";
import { MemberApi } from "@/services/Api";
import { RegisterAccountType } from "@/models/AccountRegister";
import TressTextInput from "@/components/TressTextInput.vue";
import TressDropdown from "@/components/TressDropdown.vue";
import TressAccountRegisterPrivate from "@/components/account/TressAccountRegisterPrivateForm.vue";
import TressAccountRegisterBusiness from "@/components/account/TressAccountRegisterBusinessForm.vue";
import { TressExceptions } from "@/code/TressExceptions";
import TressAccountForgottenPasswordForm from "@/components/account/TressAccountForgottenPasswordForm.vue";
import { CustomerType } from "@/enums/CustomerType";
import { useAsyncSpinner } from "@/services/Spinner";
import { DataLayerApi } from "@/services/Api";
import TressException from "@/services/TressException";

interface FormDataValues {
  password: string;
  username: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTheSignIn',
  props: {
  returnUrl: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const $t = useI18n().t;



const username = ref<string>();
const password = ref<string>();
const items: { key: RegisterAccountType; value: string }[] = [
  { key: "private", value: $t(dictionary.common.private) },
  { key: "business", value: $t(dictionary.common.business) },
];

const showForgottenPassword = ref<boolean>(false);
const showForgottenPasswordView = () => {
  showForgottenPassword.value = true;
};
const showSignInView = () => {
  showForgottenPassword.value = false;
};
const form = ref();
const isSending = ref<boolean>(false);
const registerAccountType = ref<RegisterAccountType>(
  CustomerType.Private === window.customerType ? CustomerType.Private : CustomerType.Business
);
const showRegisterAccount = ref(false);
const selectedForm = ref(CustomerType.Private == window.customerType ? CustomerType.Private : CustomerType.Business);
const onSignIn = async (values: FormDataValues) => {
  try {
    isSending.value = true;
    await useAsyncSpinner(async () => {
      const result = await MemberApi.login(values.username, values.password);
      if (result.success) {
        DataLayerApi.getUserLoginEvent();
        window.location.href = props.returnUrl ?? window.location.href;
      }
    });
  } catch (error: unknown) {
    switch (TressException(error)) {
      case TressExceptions.SignIn_Error:
        form.value.setFieldError("", $t(dictionary.form.error.signInError));
        break;
      case TressExceptions.SignIn_MissingUsername:
        form.value.setFieldError("username", $t(dictionary.form.error.missingUsername));
        break;
      case TressExceptions.SignIn_MissingPassword:
        form.value.setFieldError("password", $t(dictionary.form.error.missingPassword));
        break;
      case TressExceptions.Unknown_Error:
      default:
        form.value.setFieldError("", $t(dictionary.form.error.unknownError));
        break;
    }
  } finally {
    isSending.value = false;
  }
};

const formSuccess = ref<boolean>(false);

const onFormSuccess = () => {
  formSuccess.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (!showForgottenPassword.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_form, {
          id: "login",
          ref_key: "form",
          ref: form,
          class: "sign-in__container sign-in__container--login",
          onSubmit: onSignIn
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($t)(_unref(dictionary).account.loginToContinue)), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TressTextInput, {
                modelValue: username.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                label: _unref($t)(_unref(dictionary).form.username.label),
                class: "sign-in__login-input",
                name: "username",
                rules: "required|email"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.username.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]),
              _createVNode(TressTextInput, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                label: _unref($t)(_unref(dictionary).form.password.label),
                placeholder: _unref($t)(_unref(dictionary).form.password.placeholder),
                class: "sign-in__login-input",
                name: "password",
                rules: "required",
                type: "password"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)(_unref(dictionary).form.password.label)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label", "placeholder"])
            ]),
            _withDirectives(_createVNode(_component_v_field, { name: "" }, null, 512), [
              [_vShow, false]
            ]),
            (errors[''])
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errors[""]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                disabled: isSending.value,
                class: "button product__buy-button sign-in__login-button"
              }, _toDisplayString(_unref($t)(_unref(dictionary).account.login)), 9, _hoisted_6),
              _createElementVNode("button", {
                class: "button product__buy-button sign-in__forgot-password-button",
                type: "button",
                onClick: showForgottenPasswordView
              }, _toDisplayString(_unref($t)(_unref(dictionary).account.forgottenPassword)), 1)
            ])
          ]),
          _: 1
        }, 512),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          (!showRegisterAccount.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button sign-in__register-button",
                onClick: _cache[2] || (_cache[2] = () => (showRegisterAccount.value = !showRegisterAccount.value))
              }, _toDisplayString(_unref($t)(_unref(dictionary).account.registerAccount)), 1))
            : _createCommentVNode("", true),
          (showRegisterAccount.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!formSuccess.value)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_9, _toDisplayString(_unref($t)(_unref(dictionary).account.registerAccountHeader)), 1))
                  : _createCommentVNode("", true),
                (!formSuccess.value)
                  ? (_openBlock(), _createBlock(TressDropdown, {
                      key: 1,
                      items: items,
                      selected: selectedForm.value,
                      class: "sign-in__form-type-dropdown",
                      "onUpdate:selected": _cache[3] || (_cache[3] = (e) => (registerAccountType.value = e))
                    }, null, 8, ["selected"]))
                  : _createCommentVNode("", true),
                (registerAccountType.value === 'private')
                  ? (_openBlock(), _createBlock(TressAccountRegisterPrivate, {
                      key: 2,
                      onSuccess: onFormSuccess
                    }))
                  : _createCommentVNode("", true),
                (registerAccountType.value === 'business')
                  ? (_openBlock(), _createBlock(TressAccountRegisterBusiness, {
                      key: 3,
                      onSuccess: onFormSuccess
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !formSuccess.value]
        ]),
        _hoisted_10
      ]))
    : (_openBlock(), _createBlock(TressAccountForgottenPasswordForm, {
        key: 1,
        onBackClick: showSignInView
      }))
}
}

})